import { useEffect, useState } from 'react';

// Subscribes to a Coveo facet controller and keeps local state in sync.
// Returns the current facet state object. Handles absent facets (null/undefined) safely.
export function useFacetSubscription(facet) {
    const [state, setState] = useState(() => facet?.state ?? {});
    useEffect(() => {
        const unsubscribe = facet?.subscribe(() =>
            setState((prev) => (prev.values === facet.state.values ? prev : { ...facet.state })),
        );
        return unsubscribe;
    }, [facet]);
    return state;
}
